<script setup lang="ts">
  useZohoDeskAsap();
  const errorModal = useErrorModal();
</script>

<template>
  <div class="h-full flex flex-col">
    <UserSecondaryEmailRecommendedBanner />
    <SystemLayoutsMainMenu />
    <slot />
    <SystemLayoutsFooter />
  </div>
  <CommonErrorModal
    v-model:is-open="errorModal.isOpen.value"
    :title="errorModal.title.value"
    :message="errorModal.message.value"
    @dismiss="errorModal.dismiss()"
  />
  <CommonBillingCycleAlert />
</template>
